import React from "react";
import {Link} from "react-router-dom";
import ReactTable from "react-table";
import {Alert, Button} from "reactstrap";
import classNames from 'classnames';

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {confirmAlert} from "react-confirm-alert";
import {PrintBarcodeModal} from '../../containers/Print';
import ProductLong from "components/Labels/ProductLong";
import ProductShort from "components/Labels/ProductShort";

import Select from "react-select";
import CollectionOverride from "components/CollectionOverride";
import UniversalModalOverride from "../UniversalModalOverride";
import {Objects} from "../index";


export default class ProductsForeign extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Products._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.caliber = '';
		this.state.caliber_error = '';
		this.state.calibers = null;
		this.state.manufacturer = '';
		this.state.manufacturer_error = '';
		this.state.manufacturers = null;
		this.state.type = '';
		this.state.type_error = '';
		this.state.types = null;
		this.request = 'GET_AMMOREADY_FFLBOSS_PRODUCTS';
		this.state.transferModal = false;
		this.state.acquisitionModal = false;
		this.state.dispositionModal = false;
		this.state.products = [];
		this.state.products_error = "";
		this.state.loading = false;
		this.state.not_acquired_error = false;
		this.state.already_acquired_error = false;
		this.state.syncing = false;


	}

	customStyles = {
		menu: (provided) => ({
			...provided, zIndex: 9999
		})
	};

	printLabel = (e) => {
		const {data} = this.state;
		let pkey = e.currentTarget.id;
		let binary_id = e.currentTarget.getAttribute('data-binary-id');
		let product;
		let longBarCode, shortBarCode;
		switch (pkey) {
			case 'all':
				longBarCode = data.map((product, key) => <ProductLong key={key} product={product}/>)
				shortBarCode = data.map((product, key) => <ProductShort key={key} product={product}/>)
				break;
			default: {
				pkey = parseInt(pkey);
				product = data.find((item) => item.pkey === pkey && item.binary_id === binary_id);
				longBarCode = <ProductLong product={product}/>
				shortBarCode = <ProductShort product={product}/>
			}
		}

		confirmAlert({
			customUI: ({onClose}) => {
				return (
					<PrintBarcodeModal
						onClose={onClose}
						longBarCode={longBarCode}
						shortBarCode={shortBarCode}
						showFullLabel={true}
					/>
				);
			}
		});
	};

	handleSelectPropertyUpdate = (property, value, linked, object) => {
		let updatedState;
		if (linked) {
			if (object && object.hasOwnProperty('binary_id')) {
				updatedState = {
					[linked]: object,
					[property]: value,
				};
			} else {
				updatedState = {
					[linked]: object,
					[property]: value,
				};
			}
		} else {
			updatedState = {
				[property]: value,
			};
		}
		this.setState(updatedState);
		this.doFilter({'value': value}, {'name': property});
	};

	clearFilters = () => {
		this.setState({
			key: Math.random(),
			filter: {},
			search: '',
			startDate: '',
			endDate: '',
			filterLocation: null,
			filterStatus: null,
			filterUsed: null,

			caliber: '',
			calibers: null,
			manufacturer: '',
			manufacturers: null,
			type: '',
			types: null,
		});
		let path = window.location.pathname.replaceAll('/', ' ').titleCase().replaceAll(' ', '');
		localStorage.removeItem('table-preferences-' + path);
	}


	handleTransferProcess = async () => {
		if(this.state.not_acquired_error === false) {
			this.setState({myProduct: this.state.products, transferModal: true})
		}
	}

	/**
	 *
	 * @returns {Promise<void>}
	 */
	checkNotAcquiredError = async () => {
		this.setState({not_acquired_error: false})
		for(let i = 0; i < this.state.products.length; i++) {
			if(this.state.products[i].status !== 1) {
				this.setState({not_acquired_error: true});
				break;
			}
		}
	}

	/**
	 *
	 * @returns {Promise<void>}
	 */
	checkAlreadyAcquiredError = async () => {
		this.setState({already_acquired_error: false})
		for(let i = 0; i < this.state.products.length; i++) {
			if(this.state.products[i].status === 1 ) {
				this.setState({already_acquired_error: true});
				break;
			}
		}
	}

	/**
	 *
	 * @returns {Promise<void>}
	 */
	handleAcquisitionProcess = async () => {
		if(this.state.already_acquired_error === false) {
			this.setState({myProduct: this.state.products, acquisitionModal: true})
		}
	}

	/**
	 *
	 * @returns {Promise<void>}
	 */
	handleDispositionProcess = async () => {
		if(this.state.not_acquired_error === false) {
			this.setState({myProduct: this.state.products, dispositionModal: true})
		}
	}

	/**
	 *
	 * @returns {Promise<void>}
	 */
	transferFFL = async () => {
		await this.checkNotAcquiredError().then(this.handleTransferProcess);

	}

	/**
	 *
	 * @returns {Promise<void>}
	 */
	acquisitionAdd = async () => {
		await this.checkAlreadyAcquiredError().then(this.handleAcquisitionProcess);
	}

	/**
	 *
	 * @returns {Promise<void>}
	 */
	dispositionAdd = async () => {
		await this.checkNotAcquiredError().then(this.handleDispositionProcess);
	}

	/**
	 *
	 * @param modal
	 */
	handleReportClose = (modal) => {
		this.setState({[modal]: false});
	}

	/**
	 *
	 * @param products
	 * @param key
	 * @param valueToRemove
	 * @returns {*}
	 */
	removeObjectByKeyValue(products, key, valueToRemove) {
		return products.filter(product => product[key] !== valueToRemove);
	}

	addSerialNumber = (e) => {
		const {data, products} = this.state;
		const id = e.currentTarget.id;
		let found = products.find((entry) => entry.ammoready_id === id);

		if (!found) {
			const product = data.find((entry) => entry.ammoready_id === id);

			if (product) {
				product.highlightRow = true;
				products.push(product);

				this.setState({
					products,
					products_error: ""
				});
			}
		} else {
			found.highlightRow = false;
			this.setState({
				products: this.removeObjectByKeyValue(products, 'ammoready_id', found.ammoready_id)
			});
			// this.setState({
			// 	products_error: "Product already in list.",
			// });
		}
	};


	getAmmoreadyCloudProductsIntoFflBoss = async () => {
		this.setState({syncing: true});
		let ammoreadyModel = new API.BuildClass(Types.Products._name, 'PUT_AMMOREADY_FFLBOSS_PRODUCT');
		await ammoreadyModel.submit(null, 'PUT_AMMOREADY_FFLBOSS_PRODUCT');
		this.reloadTable();
		this.setState({syncing: false});
	}

	render() {
		const {data, pages, limit, loading,columnsAnchor} = this.state;
		const extraColumns = [
		];
		const columns = [
			{
				Header: "FFLBoss ID",
				id: "pkey",
				accessor: obj => (obj.id ? obj.id : (obj.binary_id + '-' + obj.pkey))
			},
			{
				Header: "Ammoready ID",
				id: "ammoready_id",
				accessor: obj => obj.ammoready_id
			},
			{
				Header: "Serial",
				id: "serial",
				accessor: obj => obj.serial_number
			},

			{
				Header: "SKU",
				accessor: "sku",
			},
			{
				Header: "Type",
				accessor: "type",
			},
			{
				Header: "Model",
				accessor: "model",
			},
			{
				Header: "Serial",
				accessor: "serial_number",
			},
			{
				Header: "Manufacturer",
				id: 'manufacturer',
				/** @param {Products_Object} obj */
				accessor: obj => (obj.manufacturer ? obj.manufacturers.name : obj.manufacturer_other)
			},
			{
				Header: "Caliber",
				id: 'caliber',
				/** @param {Products_Object} obj */
				accessor: obj => (obj.caliber ? obj.calibers.name : obj.caliber_other)
			},
			...extraColumns,
			{
				Header: "Status",
				id: 'status',
				/** @param {Products_Object} obj */
				accessor: obj => (obj.status ? obj.product_statuses.name : "")
			},
			{
				Header: "Location",
				id: 'location',
				/** @param {Products_Object} obj */
				accessor: obj => (obj.location ? obj.locations.name_display || obj.locations.name : "")
			},
			{
				Header: "Acq. Date",
				id: "acquisition_date",
				width: 160,
				/** @param {Products_Object} obj */
				accessor: obj => {
					return obj.acquisition_date ? moment(obj.acquisition_date)
						.local()
						.format("MM/DD/YYYY hh:mm A") : 'Never Acquired'
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Button
								id={props.original.pkey}
								data-binary-id={props.original.binary_id}
								color="blue-hoki"
								size={"sm"}
								block={true}
								onClick={this.printLabel}
							>
								<i className={"fa fa-print"}/>
							</Button>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Link to={`/products/${props.original._id}`}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<i className={"fa fa-pencil"}/></Button>
							</Link>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Link to={`/products/${props.original._id}#history`}>
								<Button color="default" size={"sm"} block={true}>
									<i className={"fa fa-file-text-o"}/></Button>
							</Link>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<Button
							id={props.original.ammoready_id}
							// binary_id={props.original.binary_id}
							// data-id={"product-"+props.original.serial_number}
							color="blue-hoki"
							size={"sm"}
							block={true}
							onClick={this.addSerialNumber}>
							<i className={props.original.highlightRow ? "fa fa-minus" :"fa fa-plus"}/>
						</Button>
					);
				}
			}

		];
		/** @type {Products_Properties} properties */
		let properties = this.model.properties;
		/** @type {Products_Object} object */
		let object = this.state;

		return (
			<Card>
				<CardContent>
					{this.state.not_acquired_error && <Alert color="danger">
						Error: One or more products have not been acquired yet. Please acquire the products first, then add them to a transfer.
					</Alert>}
					{this.state.already_acquired_error && <Alert color="danger">
						Error: One or more products have already been acquired.
					</Alert>}
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('Products', "")}
								{this.renderLocationFilter()}
								<div className="statusFilter" style={{width: '160px'}}>
									<Select
										styles={this.customStyles}
										className={classNames('basic-single', {hasSelection: this.state.filter.status != null && this.state.filter.status.length})}
										classNamePrefix="select"
										onChange={this.doFilter}
										value={this.state.filterStatus}
										isClearable={true}
										isSearchable={true}
										name="status"
										placeholder={"Status..."}
										options={[
											{value: null, label: 'All'},
											{value: 1, label: 'In Stock'},
											{value: 2, label: 'Sold'},
											{value: 3, label: 'Transferred'},
											{value: 5, label: 'Lost'},
											{value: 6, label: 'Reserved'},
											{value: 7, label: 'Destroyed'},
											// {value: 8, label: 'Never Acquired'},
											{value: 9, label: 'Rented'},
										]}
									/>
								</div>
								<div className="statusFilter" style={{width: '110px'}}>
									<Select
										styles={this.customStyles}
										className={classNames('basic-single', {hasSelection: this.state.filter.used_firearm != null && this.state.filter.used_firearm.length})}
										classNamePrefix="select"
										onChange={this.doFilter}
										value={this.state.filterUsed}
										isClearable={true}
										isSearchable={true}
										name="used_firearm"
										placeholder={"Used..."}
										options={[
											{value: null, label: 'All'},
											{value: false, label: 'New'},
											{value: true, label: 'Used'},
										]}
									/>
								</div>
								<div className={"statusFilter"}>
									<Framework.Elements.Select
										shouldLoad={true}
										update={this.handleSelectPropertyUpdate}
										name="caliber"
										property={properties.caliber}
										value={object.caliber}
										error={object.caliber_error}
										object={object.calibers}
										nullable={true}
									/>
								</div>
								<div className={"statusFilter"}>
									<Framework.Elements.Select
										shouldLoad={true}
										update={this.handleSelectPropertyUpdate}
										name="manufacturer"
										property={properties.manufacturer}
										value={object.manufacturer}
										error={object.manufacturer_error}
										object={object.manufacturers}
										nullable={true}
									/>
								</div>
								<div className={"typeFilter"}>
									<Framework.Elements.Select
										shouldLoad={true}
										update={this.handleSelectPropertyUpdate}
										name="type"
										property={properties.type}
										value={object.type}
										error={object.type_error}
										model={Types.Products_Types._name}
										id={'name'}
										nullable={true}
									/>
								</div>
								<Button
									color="warning"
									onClick={this.getAmmoreadyCloudProductsIntoFflBoss}
									style={{ marginLeft: '25px' }}
									disabled={this.state.syncing}
								>
									<i
										className={
											`fa fa-refresh ${this.state.syncing ? 'fa-spin' : ''}`
										}
										style={{ marginRight: '8px' }}
									/>
									{this.state.syncing ? 'Syncing AmmoReady Products with FFLBoss...' : 'Sync AmmoReady Products with FFLBoss'}
								</Button>
								{<Button color="primary" onClick={this.acquisitionAdd} style={{marginLeft: '25px'}}>Add to Acquisition ({this.state.products.length})</Button> }
								{<Button color="primary" onClick={this.transferFFL} style={{marginLeft: '25px'}}>Add to Transfer ({this.state.products.length})</Button> }
								{<Button color="primary" onClick={this.dispositionAdd} style={{marginLeft: '25px'}}>Add to Disposition ({this.state.products.length})</Button> }
								{this.renderHeaderRight("Products", columns, extraColumns, columnsAnchor, this.handleOpen, this.handleClose,
								)}
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							onPageSizeChange={this.onPageSizeChange}
							onSortedChange={this.onSortedChange}
							page={this.state.page}
							onPageChange={this.onPageChange}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							pageSizeOptions={[5, 10, 20, 25, 50, 100, 500, 1000, 'All']}
							renderPageSizeOptions={this.renderPageSizes}
							pageSize={limit}
							className="-striped -highlight"
							getTrProps={(state, rowInfo) => {
								if (rowInfo && rowInfo.row) {
									return {
										style: {
											background: rowInfo.original.highlightRow ? 'yellow' : 'inherit',
										},
									};
								} else {
									return {};
								}
							}}
						/>


						<UniversalModalOverride
							showModal={this.state.modalImporter}
							locations={this.props.locations}
							states={this.props.states}
							name={"Acquisition"}
							object={Objects.Acquisition}
							history={this.props.history}
							reportClose={() => this.handleReportClose('acquisitionModal')}
							afterSave={() => this.props.history.push('/acquisitions')}
							toggle={this.state.acquisitionModal}
							size={'xl'}
							objectProps={{
								transaction_entries: this.state.myProduct
								// setBackdrop: (backdrop) => this.setState({backdrop}),
								// setBypass: (bypass) => this.setState({bypass})
							}}
						/>


						<UniversalModalOverride
							locations={rootState.locations}
							states={rootState.states}
							history={this.props.history}
							name={"Transfer"}
							object={Objects.Transfer}
							toggle={this.state.transferModal}
							reportClose={() => this.handleReportClose('transferModal')}
							afterSave={() => this.props.history.push('/transfers')}
							objectProps={{transaction_entries: this.state.myProduct}}
						/>


						<UniversalModalOverride
							locations={rootState.locations}
							states={rootState.states}
							history={this.props.history}
							name={"Disposition"}
							object={Objects.DispositionAdd}
							toggle={this.state.dispositionModal}
							reportClose={() => this.handleReportClose('dispositionModal')}
							afterSave={() => this.props.history.push('/dispositions')}
							objectProps={{
								transaction_entries: this.state.myProduct
							}}
							size={'xl'}
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
